import React, { Dispatch, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep, defaults } from "lodash";
import { useInternal } from "uikit";

import { ByMulty } from "../../../../../../../../../../redux/reducers/OrdersPage/interface";
import LightInputModal from "../../../../../../../../../../components/LightInputModal";

import Content from "./components/Content";
import Footer from "./components/Footer";

const FilterOrdersByMultyModal: React.FC<FilterOrdersByMultyModal.Props> = ({
	onClose,
	onReset,
	onSubmit,

	...props
}) => {
	const { t } = useTranslation();
	const outerValue: ByMulty = useMemo(
		() =>
			defaults(cloneDeep(props.value ?? {}), {
				taxiServiceIds: [],
				taxiServices: [],
				companyIds: [],
				services: [],
				classes: [],
			}),
		[props.value],
	);

	const [value, setValue] = useState<Content.Value>(outerValue);

	const internalOnSubmit = useCallback(() => {
		onSubmit?.(value);
	}, [onSubmit, value]);

	return (
		<LightInputModal
			{...props}
			draggable={false}
			useDefaultFooter={false}
			title={
				t(
					"pages.mainPage.pages.orders.orderHeader.firstRow.filterMulty",
				) ?? ""
			}
			onClose={onClose}
			onSubmit={internalOnSubmit}
		>
			<Content value={value} onChange={setValue} />
			<Footer
				onCancel={onClose}
				onReset={onReset}
				onSubmit={internalOnSubmit}
			/>
		</LightInputModal>
	);
};

declare namespace FilterOrdersByMultyModal {
	type Value = Content.Value;

	interface Props
		extends Omit<
			LightInputModal.Props,
			"draggable" | "title" | "onSubmit"
		> {
		value?: Partial<Value>;

		onReset?: () => void;
		onSubmit?: Dispatch<Value>;
	}
}

export default FilterOrdersByMultyModal;
